import { FC, ReactNode, useContext } from "react";
import { ColumnVisibilityState } from "@tanstack/react-table";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import { ViewMode } from "@app/network-portfolio-management/interfaces";
import { ProjectTableColumnPicker } from "@app/network-portfolio-management/components/project-table/ProjectTableColumnPicker";
import { QESButton } from "@app/shared/qes-standards/Button";

const VIEW_MODE_OPTIONS: { key: ViewMode; label: string }[] = [
  { key: "cards", label: "Cards" },
  { key: "rows", label: "Rows" },
];

interface ProjectListHeaderProps {
  columnVisibility: ColumnVisibilityState;
  onColumnVisibilityChange: (visibility: ColumnVisibilityState) => void;
  onViewModeChange: (mode: ViewMode) => void;
  sortGroupSlot?: ReactNode;
  viewMode: ViewMode;
}

export const ProjectListHeader: FC<ProjectListHeaderProps> = ({
  columnVisibility,
  onColumnVisibilityChange,
  onViewModeChange,
  sortGroupSlot,
  viewMode,
}) => {
  const { enabledFeatureFlags } = useContext(FeatureFlagContext);
  const rowViewEnabled = enabledFeatureFlags.has(Features.ARGUS_PROJECT_DASHBOARD_ROW_VIEW_ENABLED);
  return (
    <header className="network-portfolio-management-project-list-header" data-testid="network-portfolio-management-project-list-header">
      <div className="network-portfolio-management-project-list-header__left">
        <div className="network-portfolio-management-project-list-header__info">
          Network Projects
        </div>
      </div>
      <div className="network-portfolio-management-project-list-header__controls">
        {sortGroupSlot}
        {rowViewEnabled && viewMode === "rows" && (
          <ProjectTableColumnPicker columnVisibility={columnVisibility} onColumnVisibilityChange={onColumnVisibilityChange} />
        )}
        {rowViewEnabled && (
          <div className="network-portfolio-management-project-list-header__view-buttons">
            {VIEW_MODE_OPTIONS.map((opt) => (
              <QESButton
                key={opt.key}
                qesType="none"
                qesTestId={`network-portfolio-management-view-${opt.key}`}
                className={`network-portfolio-management-project-list-header__view-btn${viewMode === opt.key ? " network-portfolio-management-project-list-header__view-btn--active" : ""}`}
                aria-pressed={viewMode === opt.key}
                onClick={() => onViewModeChange(opt.key)}
              >
                {opt.label}
              </QESButton>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};
